// Cross-section feed coordination for the homepage.
//
// Hero runs first and claims products. Remaining sections then fetch in
// parallel against the same exclusion snapshot so lower sections don't wait
// on each other.

const shownProductIds = new Set();
let fetchChain = Promise.resolve();
let heroGateResolve = null;
let heroGate = new Promise((resolve) => {
  heroGateResolve = resolve;
});

// Keep query strings well under URL length limits
const MAX_EXCLUDE_IDS = 150;

export function resetFeedRegistry() {
  shownProductIds.clear();
  fetchChain = Promise.resolve();
  // Keep an already-pending gate (sibling effects may be waiting on it).
  // Only open a new gate after the previous hero has completed.
  if (!heroGateResolve) {
    heroGate = new Promise((resolve) => {
      heroGateResolve = resolve;
    });
  }
}

export function completeHeroGate() {
  if (heroGateResolve) {
    heroGateResolve();
    heroGateResolve = null;
  }
}

// Serial slot — used by Hero so it alone owns the first claim.
export function fetchExclusiveFeed(fetcher) {
  const run = fetchChain.then(() =>
    fetcher([...shownProductIds].slice(0, MAX_EXCLUDE_IDS))
  );
  fetchChain = run.then(
    () => undefined,
    () => undefined
  );
  return run;
}

// After Hero finishes, all remaining sections share one exclude snapshot
// and run concurrently.
export function fetchAfterHero(fetcher) {
  return heroGate.then(() =>
    fetcher([...shownProductIds].slice(0, MAX_EXCLUDE_IDS))
  );
}

export function registerShownProducts(products) {
  products.forEach((product) => {
    const id = String(product?._id || product?.id || '');
    if (id) shownProductIds.add(id);
  });
}
